import Vue from 'vue';
// import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_AGENCY_GOODS_CATES_REQUEST,
    GET_AGENCY_GOODS_CATES_SUCCESS,
    GET_AGENCY_GOODS_CATES_FAILURE,
    CLEAR_AGENCY_GOODS_CATES,
    GET_AGENCY_LIST_REQUEST,
    GET_AGENCY_LIST_SUCCESS,
    GET_AGENCY_LIST_FAILURE,
    UPDATE_AGENCY_LIST,
    UPDATE_AGENCY_LIST_PARAMS,
    RESET_AGENCY_LIST,
    RESOLVE_AGENCY_LIST_PARAMS,
} from '../mutationTypes';

const state = {
    loading: false,
    cate1_id: '',
    cate2_id: '',
    cate3_id: '',
    cateL1: [],
    cateL2: [],
    cateL3: [],
    cateLoading: false,
    goodsStatus: 1, // 状态（1：有效，2：失效）
    isSameCity: 0, // 是否同城（0：全部，1：同城）
    isActivity: 0, // 是否活动（0：全部，1：活动）
    isFreePostage: 0, // 是否包邮（0：全部，1：包邮）
    page: 1,
    pagesize: 20,
    goodsName: '',
    goodsBrand: '',
    listData: [],
    pageCount: 1,
    reqParams: {},
    noData: false,
};

const mutations = {
    [GET_AGENCY_GOODS_CATES_REQUEST](state) {
        state.cateLoading = true;
    },
    [GET_AGENCY_GOODS_CATES_SUCCESS](state, res) {
        state.cateLoading = false;
        const { level } = res;
        state[`cateL${level || 1 || 4}`] = res.list;
    },
    [GET_AGENCY_GOODS_CATES_FAILURE](state) {
        state.cateLoading = false;
    },
    [CLEAR_AGENCY_GOODS_CATES](state, level) {
        if (level === 2) {
            // 一级不用清空
            state.cateL2 = [];
            state.cate2_id = '';
            state.cateL3 = [];
            state.cate3_id = '';
        } else if (level === 3) {
            state.cateL3 = [];
            state.cate3_id = '';
        }
    },
    [GET_AGENCY_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_AGENCY_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
        state.noData = res.listData.length === 0;
    },
    [UPDATE_AGENCY_LIST](state, res) {
        state.listData = res;
    },
    [GET_AGENCY_LIST_FAILURE](state) {
        state.loading = false;

        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_AGENCY_LIST_PARAMS](state, params) {
        const { page } = params;
        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
        state[Object.keys(params)[0]] = params[Object.keys(params)[0]];
    },
    [RESET_AGENCY_LIST](state) {
        _.extend(state, _.cloneDeep({
            loading: false,
            cate1_id: '',
            cate2_id: '',
            cate3_id: '',
            cateL1: [],
            cateL2: [],
            cateL3: [],
            cateLoading: false, // 商品分类loading
            goodsStatus: 1,
            isSameCity: 0,
            isActivity: 0,
            isFreePostage: 0,
            page: 1,
            pagesize: 20,
            goodsName: '',
            goodsBrand: '',
            listData: [],
            pageCount: 1,
            reqParams: {},
            noData: false
        }));
    },
    [RESOLVE_AGENCY_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getAgencyList({ commit }) {
        commit(GET_AGENCY_LIST_REQUEST);
        const res = await Vue.$ajax.get('agentList', state.reqParams);
        if (!res.errorType) {
            commit(GET_AGENCY_LIST_SUCCESS, res);
        } else {
            commit(GET_AGENCY_LIST_FAILURE);
        }
    },
    resolveAgencyListParams({ commit }) {
        let params = _.pick(state, ['goodsName', 'goodsBrand',
            'cate1_id', 'cate2_id', 'cate3_id',
            'goodsStatus', 'isSameCity', 'isActivity', 'isFreePostage',
            'page', 'pagesize']);

        params = Object.assign({}, params);
        commit(RESOLVE_AGENCY_LIST_PARAMS, params);
    },
    resetAgencyList({ commit }) {
        commit(RESET_AGENCY_LIST);
    },
    async getAgencyGoodsCates({ commit }, query) {
        commit(GET_AGENCY_GOODS_CATES_REQUEST);
        const { level, cateId, isOrthers } = query;
        const list = await Vue.$ajax.get('getGoodsCate', {
            cateId,
            isOrthers,
            is_noagent: 0
        });
        const res = {
            list,
            level
        };
        if (!list.errorType) {
            commit(GET_AGENCY_GOODS_CATES_SUCCESS, res);
        } else {
            commit(GET_AGENCY_GOODS_CATES_FAILURE);
        }
    },
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/agencyGoods.js